<span *ngIf="fileUrl" class="action-cell">
    <div *ngIf="isPdfFile" class="action-icons">
        <a *ngIf="showView" href="javascript:void(0)" class="pdf-link" (click)="viewPdf()" title="{{ 'lbl_common_view' | localize }}">
            <i class="fa fa-search icon"></i>
        </a>

        <span *ngIf="showView" class="pdf-separator icon">|</span>

        <a *ngIf="showDownload" href="javascript:void(0)" class="pdf-link" (click)="downloadPdf()" title="{{ 'lbl_common_download' | localize }}">
            <i class="fa fa-download icon"></i>
        </a>
    </div>
</span>
